<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e29711">ACKNOWLEDGMENTS</p>
<p class="tx" id="d7e30211">A research project this extensive requires a lot of assistance from people and organizations that share a mutual interest in the subject along with sympathy for its author. I would like to thank the following for all their help in providing me with great information and healthy doses of support: David Brown, Penny Murphy, Concetta Youngblood, Buffalo Convention &amp; Visitors Bureau, Ithaca/ Tompkins County Convention &amp; Visitors Bureau, Empire State Development, New York City Convention &amp; Visitors Bureau, Niagara Falls Convention &amp; Visitors Bureau, Syracuse Convention &amp; Visitors Bureau, Greater Rochester Visitors Association, Broome County Convention &amp; Visitors Bureau, Westchester County Convention &amp; Visitors Bureau, Lake Placid/Essex County Visitors Bureau, Albany County Convention &amp; Visitors Bureau, Otsego County Chamber of Commerce, Schoharie County Chamber of Commerce, Cayuga County Office of Tourism, and the staff of the beautiful Saratoga Springs Public Library (for leaving the lights on for me).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mend_9781418573737_epub_c7_r1.vue?7117aaf7